import React from 'react';
import PropTypes from 'prop-types';

const Input = ({ 
  label, 
  icon: Icon, 
  rightElement,
  error, 
  className = '', 
  containerClassName = '',
  id,
  ...props 
}) => {
  const inputId = id || React.useId();

  return (
    <div className={`space-y-1 ${containerClassName}`}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 ml-1">
          {label}
        </label>
      )}
      <div className="relative group">
        {Icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Icon size={18} className="text-gray-400 group-focus-within:text-blue-500 transition-colors" />
          </div>
        )}
        <input
          id={inputId}
          className={`
            block w-full 
            ${Icon ? 'pl-10' : 'pl-3'} 
            ${rightElement ? 'pr-10' : 'pr-3'}
            py-3 
            border border-gray-200 
            rounded-md 
            text-gray-900 
            placeholder-gray-400 
            focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 
            transition-all bg-white
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : ''}
            ${className}
          `}
          {...props}
        />
        {rightElement && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            {rightElement}
          </div>
        )}
      </div>
      {error && (
        <p className="text-xs text-red-500 ml-1 mt-1">{error}</p>
      )}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.elementType,
  rightElement: PropTypes.node,
  error: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string
};

export default Input;
